import React from "react";
import { FiMapPin } from "react-icons/fi";
import ServicePlanPage from "../components/options/ServicePlanPage";
import { domiciliationGuide } from "../components/guide/guideContent";
import pricing from "../assets/data/pricing.json";

function Domiciliation() {
  return (
    <ServicePlanPage
      serviceKey="domiciliation"
      icon={FiMapPin}
      title={
        <>
          Domiciliez votre entreprise chez <span>Platform98</span>
        </>
      }
      lead="Une adresse professionnelle pour votre siège social, avec la gestion de votre courrier et l'accès à nos espaces de travail."
      cardTitle="Domiciliation d'entreprise"
      summary="Votre siège social à une adresse professionnelle, avec une attestation de domiciliation."
      prices={pricing.domiciliation}
      guide={domiciliationGuide}
      note="La salle de réunion et l'espace de coworking sont accessibles sur réservation."
    />
  );
}

export default Domiciliation;
